import React from 'react';
import { Prefab } from '@gift/basic-scene-core/Prefab';
import { MinimalPrefabPreview2d } from './MinimalPrefabPreview2d';
import { FullPrefabPreview2d } from './FullPrefabPreview2d';
import { useTranslation } from 'react-i18next';

const modes = {
    'full': FullPrefabPreview2d,
    'minimal': MinimalPrefabPreview2d,
};

export const PrefabPreview2d = ({ prefab, mode }: Props) => {
    const { t } = useTranslation();
    const Mode = modes[mode];
    return (
        <div className='idt-w-full idt-h-full'>
            <Mode prefab={prefab} t={t} />
        </div>
    );
};

type Props = {
    prefab: Prefab,
    mode: 'full' | 'minimal'
};
